export const newsData = [
  {
    id: 1,
    title: 'สหกรณ์ฯ ตอบข้อซักถาม - ข้อคิดเห็นผู้แทนสมาชิก วันประชุมใหญ่สามัญประจำปี 2567',
    date: '02 เม.ย. 2568',
    time: '16:18:03 น.',
    isNew: true,
  },
  {
    id: 2,
    title: 'กำหนดการอนุมัติเงินกู้สามัญ ประจำเดือน เมษายน 2568',
    date: '01 เม.ย. 2568',
    time: '16:43:29 น.',
    isNew: true,
  },
  {
    id: 3,
    title: 'ย่อยถอดย่อ งานได้ข่าวการประชุมคณะกรรมการดำเนินการ ครั้งที่ 2 เมื่อวันที่ 23 กุมภาพันธ์ 2568',
    date: '01 เม.ย. 2568',
    time: '16:36:31 น.',
    isNew: true,
  },
  {
    id: 4,
    title: 'ประกาศสอบราคา จัดซื้อครุภัณฑ์เครื่องพิมพ์เลเซอร์พร้อมอุปกรณ์',
    date: '01 เม.ย. 2568',
    time: '12:33:01 น.',
    isNew: false,
  },
  {
    id: 5,
    title: 'แจ้งปิดทำการสหกรณ์ฯ ชั่วคราว เพื่อเฝ้าระวังเหตุการณ์แผ่นดินไหว',
    date: '29 มี.ค. 2568',
    time: '14:21:34 น.',
    isNew: false,
  }
];

export const quickLinks = [
  {
    id: 1,
    title: 'ดาวน์โหลด',
    url: '#'
  },
  {
    id: 2,
    title: 'อัตราดอกเบี้ย 2568',
    url: '#'
  },
  {
    id: 3,
    title: 'รหัสวัตถุประสงค์ การชำระเงิน/ฝากเงิน',
    url: '#'
  },
  {
    id: 4,
    title: 'คลังความรู้',
    url: '#'
  }
];

export const interestRates = {
  depositRates: [
    {
      type: 'ออมทรัพย์',
      rate: 1.75
    },
    {
      type: 'ออมทรัพย์พิเศษ',
      rate: 2.75
    },
    {
      type: 'ประจำ 12 เดือน',
      rate: 3.00
    },
    {
      type: 'ประจำ 24 เดือน',
      rate: 3.25
    }
  ],
  loanRates: [
    {
      type: 'เงินกู้สามัญ',
      rate: 5.75
    },
    {
      type: 'เงินกู้ฉุกเฉิน',
      rate: 5.75
    },
    {
      type: 'เงินกู้พิเศษ',
      rate: 5.50
    }
  ]
};

export const meetings = [
  {
    id: 1,
    title: 'สรุปข่าวสารการเคลื่อนไหวประจำเดือน กุมภาพันธ์ 2568',
    url: '#'
  },
  {
    id: 2,
    title: 'สรุปข่าวสารการเคลื่อนไหวประจำเดือน ธันวาคม 2567',
    url: '#'
  }
]; 